import moment, { Moment } from 'moment';

export function removeTimezone(dateTime: Moment): Moment {
    return moment(dateTime).utc().add(dateTime.utcOffset(), 'm');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/dates.ts